import { BikeConfig } from '../config';
import { BikeSpec, Discipline, bikeConfig } from './types';
import { YZ250F } from './yz250f';
import { CRF250R } from './crf250r';
import { KTM125SX } from './ktm125sx';
import { KTM350EXCF } from './ktm350excf';
import { KTM150EXCTPI } from './ktm150exctpi';
import { GASGASEC250 } from './gasgasec250';

export * from './types';

/** The school fleet, in garage order (lightest rider level first). */
export const FLEET: readonly BikeSpec[] = [KTM150EXCTPI, YZ250F, CRF250R, KTM125SX, KTM350EXCF, GASGASEC250];
/** School rule: every bike rides one kind of level. Defaults when the rider has not picked one for it yet. */
export const DEFAULT_BIKE_FOR: Record<Discipline, string> = { track: YZ250F.id, enduro: KTM150EXCTPI.id };
export const DEFAULT_FLEET_BIKE = DEFAULT_BIKE_FOR.track;

/** The enduro route is enduro; the training ring, the main track and the drills on them are track. */
export const disciplineOf = (levelId: string): Discipline => (levelId === 'enduro' ? 'enduro' : 'track');

export const bikeSpec = (id: string): BikeSpec => FLEET.find((b) => b.id === id) ?? YZ250F;

/** The bike a level is ridden on: the pick for its discipline when that bike may ride it, else the default. */
export function bikeForLevel(levelId: string, picks: { model: string; enduroModel: string }): string {
  const d = disciplineOf(levelId);
  const id = d === 'enduro' ? picks.enduroModel : picks.model;
  return FLEET.some((b) => b.id === id && b.discipline === d) ? id : DEFAULT_BIKE_FOR[d];
}

const configs = new Map<string, BikeConfig>();
/** Physics config of a fleet bike (cached, so one bike always hands out the same object). */
export function fleetConfig(id: string): BikeConfig {
  const s = bikeSpec(id);
  let c = configs.get(s.id);
  if (!c) { c = bikeConfig(s); configs.set(s.id, c); }
  return c;
}
